/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyLockedIcon = createIcon("EmptyLockedIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty-locked-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 55H37a4 4 0 00-4 4v28a4 4 0 004 4h36a4 4 0 004-4V59a4 4 0 00-4-4Z",
    fill: "#A5AEFF",
    stroke: "#A5AEFF",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 55V45c0-7.732 6.268-14 14-14s14 6.268 14 14v10",
    stroke: "#A5AEFF",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 49H43a4 4 0 00-4 4v28a4 4 0 004 4h36a4 4 0 004-4V53a4 4 0 00-4-4Z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 49V39c0-7.732 6.268-14 14-14s14 6.268 14 14v10",
    stroke: "#000",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 73a6 6 0 100-12 6 6 0 000 12Z",
    fill: "#665AF4",
    stroke: "#000",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-locked-a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "120",
    height: "120",
    fill: "#fff"
  }))));
}, {
  "i18nKey": "svg.EmptyLockedIcon"
});